<div class="note" [attr.data-automation]="'note-' + index()">
  <div class="d-flex">
    <strong data-automation="order-note-author">{{ note().userId }}</strong>
    <span class="ms-2" data-automation="order-note-date">{{ note().lastModifiedDate | date: 'MMMM d, h:mm a' }}</span>
  </div>
  <div class="d-flex">
    <div class="note__description-icon">
      <i [ngClass]="ziroIcons.CIRCLE_USER" class="fa-2x align-self-center" [style]="'color:' + iconColor"></i>
    </div>
    <p class="note__description-text" data-automation="order-note-description">{{ note().description }}</p>
  </div>
  @if (!isLastNote()) {
    <hr />
  }
</div>
